
import { useState, useEffect, useMemo } from 'react';
import AddPhotoButton from './AddPhotoButton';
import styles from './stepPictures.module.scss';
import CustomFileUploader from '../../CustomFileUploader/CustomFileUploader';
import { TRANSMISSION_TYPES, TYPE_TYPES } from '../../../constants/salePost';
import { FUEL_TYPES, COLORS } from '../../../constants/Publication';
import { TextField, MenuItem } from '@mui/material';
import { optionsAccidentsReported, optionsPersonalUse, optionsSoleOwner } from '../../../constants/app';
import { uploaderImages } from '../../../constants/uploaderImages';
import { useToast } from '../../../helpers/hooks';
import Button from '../../Button';
import CheckIcon from '@mui/icons-material/Check';
import Box from '@mui/material/Box';
import { StepPicturesProps, ImageFile } from '../../../interfaces/salePost';
import Tooltip from '@mui/material/Tooltip';
import imageCompression from 'browser-image-compression'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import FeaturesList from '../FeaturesModal/FeaturesList';
import { capitalize, getYears as calculateYears, formatInput, addPointsInText } from "../../../helpers/app";


const selectProps = {
    MenuProps: {
        PaperProps: {
            style: { maxHeight: 200 }
        },
        anchorOrigin: {
            vertical: "bottom" as const,
            horizontal: "left" as const
        },
        transformOrigin: {
            vertical: "top" as const,
            horizontal: "left" as const
        }
    }
};

const DOORS_OPTIONS = [
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
];

const sxTextFieldDefault = {
  backgroundColor: '#fff',
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: 'black',
    },
    '&:hover fieldset': {
      borderColor: 'black',
    },
  },
  '& .MuiInputLabel-root': {
    '&.Mui-focused': {
      color: 'black',
    },
  },
};
const StepPictures = ({
  postPublicationsImages,
  deletePublicationImage,
  fetchingDeleteImage,
  cleanDeleteImage,
  imagesVideos,
  setImages,
  plate,
  isFoundPlate,
  onContinue,
  files,
  onValidityChange,
  fuel,
  version,
  versions,
  getVersions,
  fetchingVersions,
  setVersion,
  setFuel,
  setYear,
  year,
  vehicleType,
  setType,
  transmission,
  setTransmission,
  doors,
  setDoors,
  additionalCharacters,
  getAdditionalCharacters,
  setAdditionalCharacters,
  selectedAdditionalCharacters,
  setSelectedAdditionalCharacters,
  cleanGetVersions,
  getYears,
  years,
  cleanGetYears,
  versionIndex,
  publication,
}: StepPicturesProps) => {
  const [additionalUploaders, setAdditionalUploaders] = useState<number[]>([]);
  const [uploadedImagesMeta, setUploadedImagesMeta] = useState<ImageFile[]>([]);

  const toast = useToast();
  const customIconStyle = {
        width: 10,
        height: 10,
        border: '1px solid green',
        padding: 0.5,
        borderRadius: '50%',
        display: 'flex',
        marginRight: 2,
        alignItems: 'center',
        justifyContent: 'center'
    };
      const [fuelSelected, setFuelSelected] = useState<string>("");
      const [typeSelected, setTypeSelected] = useState<string>("");
      const [transmissionSelected, setTransmissionSelected] = useState<string>("");
      const [doorsSelected, setDoorsSelected] = useState<string>("");
      const [versionSelected, setVersionSelected] = useState<any>({ id: null, name: null });
      const [yearInput, setYearInput] = useState<string>("");
      const [priceInput, setPriceInput] = useState<string>("");
      const [hasInitialized, setHasInitialized] = useState(false);
    const isEditing = !!publication?.data;

  const [realImageIds, setRealImageIds] = useState<string[]>([]);
  const [uploadsInProgress, setUploadsInProgress] = useState<Set<string>>(new Set());
  const [hasMinRequiredImages, setHasMinRequiredImages] = useState<boolean>(false);
  const [disableAddMoreButton, setDisableAddMoreButton] = useState<boolean>(true);
  const [disabledButton, setDisabledButton] = useState<boolean>(true);

  
  
  useEffect(() => {
    if (realImageIds.length > 0) {
      try {
        const storageKey = versionIndex !== undefined 
          ? `linze_real_image_ids_version_${versionIndex}` 
          : 'linze_real_image_ids';
        localStorage.setItem(storageKey, JSON.stringify(realImageIds));
      } catch (err) {
        console.error('Error al guardar IDs en localStorage:', err);
      }
    }
  }, [realImageIds, versionIndex]);
  const MAX_IMAGES = 10;
  const minRequiredIndices = [0, 1, 2, 3]; 
  const allRequiredIndices = [1, 2, 3, 4]; 

  const checkRequiredImages = (images: ImageFile[] = []) => {
    if (!images || images.length === 0) {
      setHasMinRequiredImages(false);
      setDisableAddMoreButton(true);
      return false;
    }
    
    const activeImages = images.filter(img => !img?.toDelete);
    
    const principalImages = activeImages.filter(img => 
    typeof img.index === 'number' && 
    minRequiredIndices.includes(img.index) && 
    img.id && 
    !img.id.startsWith('temp-')
  );
  
  const validImagesWithIds = activeImages
    .filter(img => img.id && !img.id.startsWith('temp-') && !img.toDelete)
    .map(img => ({ indice: img.index, id: img.id }));
  
    const hasMinimumRequired = principalImages.length >= 4;
    
    minRequiredIndices.forEach(index => {
      const imgFound = activeImages.find(img => 
        typeof img.index === 'number' && img.index === index && img.id
      );
    
    });
    
    const hasAllRequired = principalImages.length >= 4;
    const shouldEnableAdditional = hasMinimumRequired;
    
    

    setHasMinRequiredImages(shouldEnableAdditional);
    
    if (shouldEnableAdditional) {
      setDisableAddMoreButton(activeImages.length >= MAX_IMAGES);
    } else {
      setDisableAddMoreButton(true);
    }
    
    return hasAllRequired; 
  };

  const formatPriceDisplay = (value: string) => {
    const num = parseInt(value);
    if (!value || isNaN(num)) return '';
    return `$${num.toLocaleString('es-CL')}`;
  };
  
  const canUploadRequiredImage = (targetIndex: number) => {
    return true;
  };

  const canUploadAdditionalImages = () => {
    const currentImages = (imagesVideos && imagesVideos.length > 0) ? imagesVideos : uploadedImagesMeta || [];
    
    const requiredComplete = minRequiredIndices.every(index => {
      const img = currentImages.find(img => 
        img.index === index && 
        img.id && 
        !img.id.startsWith('temp-') && 
        img.uploaded && 
        img.upload === 'success' && 
        !img.toDelete && 
        !img.deleted
      );
      
      return !!img;
    });
    
    return requiredComplete;
  };

  const shouldDisableAdditionalUploader = (targetIndex: number) => {
    const currentImages = (imagesVideos && imagesVideos.length > 0) ? imagesVideos : uploadedImagesMeta || [];
    const hasExistingImage = currentImages.some(img => img.index === targetIndex && !img.toDelete && !img.deleted);
    
    if (hasExistingImage) {
      return false;
    }
    
    const canUpload = canUploadAdditionalImages();
    return !canUpload;
  };

  const checkRequiredFields = () => {
    const currentImages = (imagesVideos && imagesVideos.length > 0) ? imagesVideos : uploadedImagesMeta || [];
    
    checkRequiredImages(currentImages);
    const hasEnoughRealIds = Array.isArray(realImageIds) && realImageIds.length >= 4;
    const requiredImagesWithValidIds = minRequiredIndices
        .filter(index => 
            currentImages?.some(img => 
                img.index === index && 
                img.id && 
                !img.id.startsWith('temp-') &&
                img.uploaded &&
                !img.toDelete &&
                !img.deleted
            )
        );
        
    const allRequiredUploaded = requiredImagesWithValidIds.length >= 4;
    
    const hasVersion = !!(versionSelected?.name || versionSelected?.id || (typeof versionSelected === 'string' && versionSelected.length > 0));
    const hasYear = !!yearInput && !isNaN(parseInt(yearInput));
    const hasValidFuel = !!fuelSelected;
    const hasValidTransmission = !!transmissionSelected;
    const hasValidDoors = !!doorsSelected;
    const hasValidType = !!typeSelected;

    let priceElement: any = document.getElementById(':r78:');
    
    if (!priceElement) {
      const inputs = document.getElementsByTagName('input');
      for (let i = 0; i < inputs.length; i++) {
        const input = inputs[i];
        if (input.placeholder === '$10.000.000' || 
            (input.value && input.placeholder?.includes('$'))) {
          priceElement = input;
          break;
        }
      }
    }
  
    const imagesValid = allRequiredUploaded;

    const hasValidPrice = typeof priceInput === 'string' && priceInput.trim().length > 0;
   
    
    const isValid = hasVersion && hasYear && hasValidTransmission && hasValidType && hasValidFuel && hasValidDoors && imagesValid && hasValidPrice &&
    !anyImageUploading && !currentImages.some(img =>
      typeof img.index === 'number' &&
      img.index >= 4 &&
      img.index <= 11 &&
      img.upload === "loading" &&
      !img.toDelete
    )

   
    setDisabledButton(!isValid);

    
    return isValid;
  };

  useEffect(() => {
    if (hasInitialized) return;
    if (!publication?.data?.vehicles || versionIndex === undefined) return;
  
    const vehicleData = publication.data.vehicles[versionIndex];
    if (!vehicleData) return;

    setHasInitialized(true);
  
    if (vehicleData.version) {
      setVersionSelected({ name: vehicleData.version });
      setVersion?.({ label: vehicleData.version });
    }
  
    if (vehicleData.year) {
      setYearInput(vehicleData.year.toString());
      setYear?.(vehicleData.year);
    }
  
    if (vehicleData.price) {
      setPriceInput(vehicleData.price.toString());
    }
  
    if (vehicleData.fuel) {
      setFuelSelected(vehicleData.fuel);
      setFuel?.(vehicleData.fuel);
    }
  
    if (vehicleData.transmission) {
      setTransmissionSelected(vehicleData.transmission);
      setTransmission?.(vehicleData.transmission);
    }
  
    if (vehicleData.doors) {
      setDoorsSelected(vehicleData.doors.toString());
      setDoors?.(vehicleData.doors);
    }
  
    if (vehicleData.type) {
      setTypeSelected(vehicleData.type);
      setType?.(vehicleData.type);
    }
  
    if (vehicleData.selectedAdditionalCharacters) {
      setSelectedAdditionalCharacters?.(vehicleData.selectedAdditionalCharacters);
    }
    if (Array.isArray(vehicleData.images)) {
      const normalizedImages = vehicleData.images.map((img: any, idx: number) => ({
        ...img,
        index: idx, 
        upload: "success",
        uploaded: true,
        previewURL: img.path || img.url || img.previewURL || '',
      }));
    
      setImages?.(normalizedImages);
      setUploadedImagesMeta(normalizedImages);

    }
    
  
  }, [publication?.data?.vehicles, versionIndex]);
  
  
  useEffect(() => {
    if (Array.isArray(imagesVideos)) {
      

      minRequiredIndices.forEach(index => {
        const imgFound = imagesVideos.find(img => 
          typeof img.index === 'number' && 
          img.index === index && 
          !img?.toDelete
        );
        
      });
      
      checkRequiredImages(imagesVideos);
    }
    
    
    checkRequiredFields();
  }, [imagesVideos]);
  
  useEffect(() => {
    checkRequiredFields();
  }, [versionSelected, yearInput, fuelSelected, transmissionSelected, doorsSelected, typeSelected]);

  const handleDeleteImage = (image: ImageFile) => {

    if (image && image.id) {

      if (!image.id.startsWith('temp-')) {

        deletePublicationImage(image.id);
      }

      const currentImages = imagesVideos || [];
      const updatedImages = currentImages.map(img => {
        if (img.id === image.id) {
          return {
            ...img,
            toDelete: true,
            deleted: true,
            previewURL: ""
          };
        }
        return img;
      });

      setUploadedImagesMeta(prev => prev.filter(img => img.id !== image.id));

      if (setImages) {

        const activeImages = updatedImages.filter(img => !img.toDelete);
        setImages(updatedImages);
        
        setTimeout(() => {
          updateAdditionalUploaders(updatedImages);
          checkRequiredFields(); 
        }, 10);
      }
      
      setTimeout(() => {
        const currentImages = (imagesVideos && imagesVideos.length > 0) ? imagesVideos : uploadedImagesMeta || [];
        updateAdditionalUploaders(currentImages);
        checkRequiredFields(); 
      }, 10);
    }
  };

  const anyImageUploading = useMemo(() => {
    return Array.isArray(imagesVideos) && imagesVideos.some(img => img.upload === "loading");
  }, [imagesVideos]);

  

  const onChangeFileUploader = async (files: ImageFile[], startIndex: number) => {
    try {

      const validatedFiles = await validateAndLimitFiles(files, startIndex);
      if (!validatedFiles) return;

      const processedFiles = await processImageFiles(validatedFiles);

      const tempFiles = processedFiles.map((file, fileIdx) => ({
        ...file,
        upload: "loading" as "loading" | "success" | "failure",
        id: `temp-${startIndex}-${Date.now()}-${fileIdx}-${Math.random().toString(36).substr(2, 4)}`
      }));
      
      const updatedImages = manageImageIndexes(tempFiles, startIndex);

      await uploadImages(updatedImages);

      updateAdditionalUploaders(updatedImages);
      
    } catch (error) {
      console.error("Error en onChangeFileUploader:", error);
    }
  };

  const validateAndLimitFiles = async (files: ImageFile[], startIndex: number) => {
    let currentImages = imagesVideos || [];
    const activeCount = currentImages.filter(img => !img.toDelete).length;

    if (activeCount + files.length > 12) {
      const availableSlots = 12 - activeCount;
      if (availableSlots <= 0) {
        toast("Ya alcanzaste el máximo de 12 imágenes permitidas.");
        return null;
      }

      const limitedFiles = files.slice(0, availableSlots);
      toast(`Solo puedes subir ${availableSlots} imagen${availableSlots > 1 ? 'es' : ''} más.`);
      return limitedFiles;
    }

    return files;
  };

  const processImageFiles = async (files: ImageFile[]): Promise<any[]> => {
    return Promise.all(
      files.map(async (file) => {
        try {
          if (!file.file) return file;

          const originalImage = await createImageBitmap(file.file);
          const { canvas, ctx } = createCanvasWithImage(originalImage);

          const recreatedBlob = await canvasToBlob(canvas, file.file.type);

          const compressedFile = await compressImage(recreatedBlob, originalImage);

          const previewURL = URL.createObjectURL(compressedFile);

          return {
            ...file,
            file: compressedFile,
            previewURL,
            name: file.name,
            id: file.id,
          };
        } catch (error) {
          return file;
        }
      })
    );
  };

  const createCanvasWithImage = (image: ImageBitmap) => {
    const canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;

    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error("No se pudo obtener el contexto del canvas.");

    ctx.drawImage(image, 0, 0);
    return { canvas, ctx };
  };

  const canvasToBlob = (canvas: HTMLCanvasElement, mimeType: string): Promise<Blob> => {
    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (blob) resolve(blob);
        else reject(new Error("No se pudo crear el Blob desde el canvas"));
      }, mimeType || "image/jpeg", 0.95);
    });
  };

  const compressImage = async (blob: Blob, originalImage: ImageBitmap) => {
    const originalSizeMB = blob.size / (1024 * 1024);

    const options = {
      maxSizeMB: 9,
      maxWidthOrHeight: 2048,
      useWebWorker: true,
      preserveExif: false
    };

    if (blob.size > 20 * 1024 * 1024) {
      options.maxWidthOrHeight = 1600;
    }

    try {
      const compressedFile = await imageCompression(blob, options);

      const compressedSizeMB = compressedFile.size / (1024 * 1024);

      return compressedFile;
    } catch (error) {
      const compressedFile = await imageCompression(blob, {
        ...options,
        maxWidthOrHeight: 1200,
        initialQuality: 0.7
      });

      const compressedSizeMB = compressedFile.size / (1024 * 1024);
      return compressedFile;
    }
  };

  const manageImageIndexes = (files: ImageFile[], startIndex: number) => {
    const currentImages = (imagesVideos && imagesVideos.length > 0) ? imagesVideos : uploadedImagesMeta || [];
    
    let allImages = [...currentImages];
    let newFiles: ImageFile[] = [];

    if (startIndex <= 3) {
      
      newFiles = files.map(file => ({
        ...file,
        index: startIndex,
        id: file.id, 
        uploaded: false
      }));
      
      allImages = allImages.filter(img => img.index !== startIndex);
      
    } else if (startIndex === 4 && !isEditing && files.length > 1) {
      const activeImages = allImages.filter(img => !img.toDelete && !img.deleted);
      const usedIndices = activeImages
        .filter(img => img.index >= 4)
        .map(img => img.index);

      let nextIndex = 4;
      newFiles = files.map((file, i) => {
        while (usedIndices.includes(nextIndex) && nextIndex < 12) {
          nextIndex++;
        }
        const assignedIndex = Math.min(nextIndex, 11);
        nextIndex++;
        return {
          ...file,
          index: assignedIndex,
          id: file.id, 
          uploaded: false
        };
      });
    } else {
      newFiles = files.map(file => ({
        ...file,
        index: startIndex,
        id: file.id, 
        uploaded: false
      }));
      
      allImages = allImages.filter(img => img.index !== startIndex);
    }

    const updatedImages = [...allImages, ...newFiles];
    
    if (isEditing) {
      setImages?.(updatedImages);
    } else {
      setUploadedImagesMeta(updatedImages);
    }
    
    checkRequiredImages(updatedImages);
    return updatedImages;
  };

  const uploadImages = async (images: ImageFile[]) => {
    const imagesToUpload = images.filter(img => {
      const hasTemporaryId = img.id?.startsWith('temp-');
      const isAlreadyProcessed = img.uploaded || img.upload === "success" || !hasTemporaryId;
      const isCurrentlyUploading = uploadsInProgress.has(img.id || '');
      
      const isValid = img?.previewURL && 
        img?.file && 
        !img.toDelete &&
        hasTemporaryId && 
        !isAlreadyProcessed && 
        !isCurrentlyUploading;
    
      return isValid;
    });
    
    if (imagesToUpload.length === 0) {
      return;
    }

    setUploadedImagesMeta(prev => {
      const loadingImages = imagesToUpload.map(img => ({
        ...img,
        upload: "loading" as const,
        uploaded: false,
        index: img.index ?? 0, 
      }));
    
      const updated = [...prev.filter(p => !loadingImages.some(n => n.id === p.id)), ...loadingImages];
      return updated as ImageFile[];
    });
    
    
    const uploadedImages = images.map(img => {
      if (imagesToUpload.some(uploadImg => uploadImg.id === img.id)) {
        return { ...img, upload: "loading" };
      }
      return img;
    });
    
    setImages?.(uploadedImages);
    

    setUploadsInProgress(prev => {
      const newSet = new Set(prev);
      imagesToUpload.forEach(img => newSet.add(img.id || ''));
      return newSet;
    });
    
    for (const img of imagesToUpload) {
      try {
        if (!img.file) continue; 
        
        const formData = new FormData();
        formData.append("file", img.file, img.name || 'image.jpg');
        
        const res = await postPublicationsImages(formData, img.id);
        
        if (res?.data?.file?.id) {
          const realImageId = res.data.file.id;
          const imagePath = res.data.file.path;
          
          
          
         
          setUploadsInProgress(prev => {
            const newSet = new Set(prev);
            newSet.delete(img.id || '');
            return newSet;
          });

          setUploadedImagesMeta(prev => {
            const newMeta: ImageFile = {
              ...img,
              id: realImageId,
              index: img.index ?? 0, 
              previewURL: imagePath,
              upload: "success" as const,
              uploaded: true,
            };
          
            const withoutOld = prev.filter(item => item.id !== img.id && item.id !== realImageId);
            return [...withoutOld, newMeta];
          });
          
          
          
          setRealImageIds(prevIds => {
            if (!prevIds.includes(realImageId)) {
             
              return [...prevIds, realImageId];
            } else {
              return prevIds;
            }
          });
          
          setImages?.((prevImages: any) =>
            prevImages.map((image: any) =>
              image.id === img.id
                ? {
                  ...image,
                  id: realImageId,
                  previewURL: imagePath,
                  upload: "success",
                  path: imagePath,
                  uploaded: true,
                  file: undefined,
                  index: image.index
                }
                : image
            )
          );
        } else {
          console.error(`Respuesta incompleta para imagen ${img.index}:`, res);
        }
      } catch (error) {
        console.error(`Error subiendo imagen ${img.id} (índice ${img.index}):`, error);
        
        
        setUploadsInProgress(prev => {
          const newSet = new Set(prev);
          newSet.delete(img.id || '');
          return newSet;
        });
        
        setImages?.((prevImages: any) =>
          prevImages.map((image: any) =>
            image.id === img.id
              ? {
                ...image,
                upload: "failure",
              }
              : image
          )
        );
      }
    }
    
    setTimeout(() => {
      setImages?.((prevImages: any) => {
        const activeImages = prevImages.filter((img: any) => !img.toDelete);
        const uploadedWithIds = activeImages.filter((img: any) => 
          img.id && !img.id.startsWith('temp-') && img.upload === "success"
        );
        
        return prevImages; 
      });
      
      checkRequiredFields();
    }, 100);
  };

  const updateAdditionalUploaders = (images: ImageFile[]) => {
    
    const extraImages = images.filter(img => 
      typeof img.index === 'number' && 
      img.index >= 5 && 
      !img.toDelete && 
      !img.deleted
    );
    
    
    if (extraImages.length === 0) {
      setAdditionalUploaders([]);
      checkRequiredFields();
      return;
    }

    const usedIndices = extraImages.map(img => 
      typeof img.index === 'number' ? img.index - 5 : 0
    );
    
    const maxUsedIndex = usedIndices.length > 0 ? Math.max(...usedIndices) : -1;
    const uploaderCount = maxUsedIndex + 1;

    setAdditionalUploaders(Array.from({ length: uploaderCount }, (_, i) => i));
    
    checkRequiredFields();
  };

  useEffect(() => {
    if (Array.isArray(imagesVideos)) {

      const imagesWithIndices = imagesVideos.map((img: ImageFile, idx: number) => {
        if (img && !img.hasOwnProperty('index')) {
          return { ...img, index: idx };
        }
        return img;
      })
      if (JSON.stringify(imagesWithIndices) !== JSON.stringify(imagesVideos)) {
        setImages && setImages(imagesWithIndices);
      }
      checkRequiredImages(imagesVideos);
    }
  }, [imagesVideos]);

  useEffect(() => {
    if (!Array.isArray(uploadedImagesMeta)) return;
  
    const hasMinRequiredImages = [0, 1, 2, 3].every(index =>
      uploadedImagesMeta.some(img => {
        const basicValidation = img.index === index && img.id && !img.toDelete;
        
        if (isEditing) {
         
          return basicValidation && (img.upload === 'success' || img.upload === 'loading' || (img.id && !img.id.startsWith('temp-')));
        } else {
       
          return basicValidation && (img.upload === 'success' || img.upload === 'loading' || (img.id && !img.id.startsWith('temp-')));
        }
      })
    );
  
    if (!hasMinRequiredImages) {
      setAdditionalUploaders([]);
      return;
    }
  
    const hasIndex4Image = uploadedImagesMeta.some(img => {
      const basicValidation = img.index === 4 && img.id && !img.toDelete;
      
      if (isEditing) {
       
        return basicValidation && (img.upload === 'success' || img.upload === 'loading' || (img.id && !img.id.startsWith('temp-')));
      } else {
        
        return basicValidation && (img.upload === 'success' || img.upload === 'loading' || (img.id && !img.id.startsWith('temp-')));
      }
    });
  
    if (!hasIndex4Image) {
      setAdditionalUploaders([]);
      return;
    }
  
    const uploadedAdicionales = uploadedImagesMeta.filter(
      img => typeof img.index === 'number' && img.index >= 5 && !img.toDelete
    );
  
    
    if (uploadedAdicionales.length === 0) {
      setAdditionalUploaders([0]); 
      return;
    }
  
    const uniqueIndexes = Array.from(
      new Set(uploadedAdicionales.map(img => img.index ?? -1).filter(i => i !== -1))
    );
  
    const maxUploaderCount = 12 - 5;
  
    if (uniqueIndexes.includes(11)) {
      setAdditionalUploaders(Array.from({ length: 7 }, (_, i) => i));
      return;
    }
  
    const uploaderCount = Math.min(uniqueIndexes.length + 1, maxUploaderCount);
    setAdditionalUploaders(Array.from({ length: uploaderCount }, (_, i) => i));
  }, [uploadedImagesMeta]);
  
  
  
  useEffect(() => {
    if (year && year !== parseInt(yearInput)) {
      setYearInput(year.toString());
    }
  }, [year]);

      

    const yearsNormalized = useMemo(() => {
        const years = calculateYears(13);
        return years.map((year: number) => ({
            id: year,
            name: year
        }));
    }, []);
    
 const handleChangeVersion = (id: string) => {
        const parsedId = parseInt(id);
        if (parsedId === -1) {
            const other = { id: -1, name: "OTRA" };
            setVersionSelected(other);
            if (setVersion) {
                setVersion({ id: -1, label: "OTRA" });
            }
            return;
        }

        const versionFound = versionsNormalized.find((item: any) => item?.id === parsedId);
        if (versionFound) {
            setVersionSelected(versionFound);
            if (setVersion) {
                setVersion({ id: versionFound.id, label: versionFound.name });
            }
        }
    }

    const handleVersionInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const versionName = event.target.value;
        const versionValue = { 
            name: versionName 
        };
        
        setVersionSelected(versionValue);
        if (setVersion) {
            setVersion({ label: versionName });
        }
    }

    const handleChangeType = (value: string) => {
        const vehicleTypeNormalized = TYPE_TYPES.find(
            type => type.value.toUpperCase() === value.toUpperCase()
        )?.value;

        if (vehicleTypeNormalized) {
            setTypeSelected(vehicleTypeNormalized);
            if (setType) {
                setType(vehicleTypeNormalized);
            }
        }
    }

    const handleChangeTransmission = (value: string) => {
        setTransmissionSelected(value);
        if (setTransmission) {
            setTransmission(value);
        }
    }

    const versionsNormalized: any = useMemo(() => {
        const normalized = versions
            ?.filter((version: any) => version?.name?.toLowerCase() !== "otra")
            .map((version: any) => ({
                id: version?.version_id,
                name: version?.name
            })) || [];

        return [...normalized, { id: -1, name: "OTRA" }];
    }, [versions]);

        const typesNormalized: any = useMemo(() => {
            return TYPE_TYPES && TYPE_TYPES.map((type: any) => (
                {
                    id: type?.id,
                    name: type?.value,
                    value: type?.value
                }
            ))
        }, [TYPE_TYPES]);
    
        const transmissionsNormalized: any = useMemo(() => {
            return TRANSMISSION_TYPES && TRANSMISSION_TYPES.map((transmission: any, index: number) => (
                {
                    id: index,
                    name: transmission,
                    value: transmission
                }
            ))
        }, [TRANSMISSION_TYPES]);
    
    
        const fuelsNormalized: any = useMemo(() => {
            return FUEL_TYPES && FUEL_TYPES.map((fuel: any, index: number) => (
                {
                    id: index,
                    name: capitalize(fuel),
                    value: fuel
                }
            ))
        }, [FUEL_TYPES]);
    
            const handleChange = (field: string) => (event: any) => {
        const value = event.target.value;


        switch (field) {
            case 'combustible':
                if (FUEL_TYPES.includes(value)) {
                    setFuel(value.toLowerCase());
                }
                break;
            case 'transmision':
                setTransmission(value);
                break;
            case 'tipo':
                setType(value);
                break;
        }
    };

      const handleYearChange = (yearValue: string) => {
        const yearInt = parseInt(yearValue);

        if (cleanGetVersions) cleanGetVersions();
    
        setVersionSelected({ id: null, name: null });

        if (setYear) {
            setYear(yearInt);
        }

    };

    const handleContinue = () => {
      const isValid = checkRequiredFields();
      if (!isValid) {
        return; 
      }
      const allImages = (imagesVideos && imagesVideos.length > 0) ? imagesVideos : uploadedImagesMeta || [];
      
      const validImages = allImages
        .filter(img => {
          const hasImg = !!img;
          const hasId = !!img.id;
          const isString = typeof img.id === 'string';
          const notTemp = !img.id?.startsWith('temp-');
          const longEnough = (img.id?.length || 0) > 8;
          const notDeleted = !img.toDelete;
          const hasIndex = typeof img.index === 'number';

          return hasImg && hasId && isString && notTemp && longEnough && notDeleted && hasIndex;
        })
        .sort((a, b) => (a.index || 0) - (b.index || 0)); 

      const imageIds = validImages.map(img => img.id);
    
      const hasAllRequiredImages = minRequiredIndices.every(index =>
        validImages.some(img => img.index === index)
      );
    
      const finalIds = imageIds.length >= 4 ? imageIds : [];
    
      if (finalIds.length < 4) {
        return;
      }
    
      const payload = {
        version: { name: versionSelected?.name || '' },
        year: parseInt(yearInput) || new Date().getFullYear(),
        price: priceInput ? parseInt(priceInput.replace(/\D/g, '')) : 0,
        fuel: fuelSelected,
        transmission: transmissionSelected,
        doors: parseInt(doorsSelected) || 4,
        type: typeSelected,
        selectedAdditionalCharacters,
        pictures: finalIds
      };
      onValidityChange && onValidityChange(true);
      onContinue && onContinue(payload);
    };
    
    
    useEffect(() => {
      if (hasInitialized) {
        checkRequiredFields();
      }
    }, [hasInitialized]);

    
    useEffect(() => {
      if (hasInitialized) {
        checkRequiredFields();
      }
    }, [priceInput]);
    
    
    useEffect(() => {
      if (isEditing && Array.isArray(imagesVideos)) {
        const initialRealIds = imagesVideos
          .filter(img => 
            img.id &&
            typeof img.id === 'string' &&
            !img.id.startsWith('temp-') &&
            !img.toDelete
          )
          .map(img => img.id);
    
        setRealImageIds(prev => {
          if (prev.length === 0 && initialRealIds.length > 0) {
            return initialRealIds;
          }
          return prev;
        });
      }
    }, [isEditing, imagesVideos]);

    
  return (
    <div className={styles.picturesVideoContainer}>

      <div className={styles.selectsGrid}>

        <div className={`${styles.selectsRow} ${styles.versionLayout}`}>
          <TextField
            required
            label="Nombre la versión"
            value={versionSelected?.name || ''}
            onChange={handleVersionInputChange}
            sx={sxTextFieldDefault}
            placeholder="Ingresa el nombre de la versión"
            InputProps={{
              endAdornment: versionSelected?.name ? (
                <Box sx={customIconStyle}>
                  <CheckIcon sx={{ color: 'green', fontSize: 15 }} />
                </Box>
              ) : null
            }}
          />

          <TextField
            select
            required
            label="Carrocería"
            value={typeSelected || ''}
            sx={sxTextFieldDefault}
            onChange={(e) => handleChangeType(e.target.value)}
            SelectProps={{
              ...selectProps,
              IconComponent: (props) =>
                typeSelected ? (
                  <Box sx={customIconStyle}>
                    <CheckIcon sx={{ color: 'green', fontSize: 15 }} />
                  </Box>
                ) : (
                  <ArrowDropDownIcon {...props} />
                ),
            }}
          >
            {typesNormalized?.map((type: any) => (
              <MenuItem key={type.id} value={type.value}>
                {type.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            required
            label="Año"
            type="text"
            value={yearInput}
            sx={sxTextFieldDefault}
            onChange={(e) => {
              const yearValue = e.target.value;
              if (/^\d*$/.test(yearValue) && yearValue.length <= 4) {
                setYearInput(yearValue);
                if (setYear && yearValue.length === 4) {
                  setYear(parseInt(yearValue));
                }
              }
            }}
            placeholder="Ej: 2025"
            inputProps={{
              maxLength: 4
            }}
            InputProps={{
              endAdornment: yearInput.length === 4 ? (
                <Box sx={customIconStyle}>
                  <CheckIcon sx={{ color: 'green', fontSize: 15 }} />
                </Box>
              ) : null
            }}
          />
        </div>


        <div className={`${styles.selectsRow} ${styles.fourColumns}`}>
          <TextField
            select
            label="Cantidad puertas"
            required
            value={doorsSelected || ''}
            sx={sxTextFieldDefault}
            onChange={(e) => {
              const doorsValue = e.target.value;
              setDoorsSelected(doorsValue);
              if (setDoors) {
                const doorsInt = parseInt(doorsValue);
                setDoors(doorsInt);
              }
            }}
            SelectProps={{
              ...selectProps,
              IconComponent: (props) =>
                doorsSelected ? (
                  <Box sx={customIconStyle}>
                    <CheckIcon sx={{ color: 'green', fontSize: 15 }} />
                  </Box>
                ) : (
                  <ArrowDropDownIcon {...props} />
                ),
            }}
          >
            {DOORS_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            required
            label="Transmisión"
            value={transmissionSelected}
            sx={sxTextFieldDefault}
            onChange={(e) => handleChangeTransmission(e.target.value)}
            SelectProps={{
              ...selectProps,
              IconComponent: (props) =>
                transmissionSelected ? (
                  <Box sx={customIconStyle}>
                    <CheckIcon sx={{ color: 'green', fontSize: 15 }} />
                  </Box>
                ) : (
                  <ArrowDropDownIcon {...props} />
                ),
            }}
          >
            {transmissionsNormalized?.map((transmission: any) => (
              <MenuItem key={transmission.id} value={transmission.value}>
                {transmission.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            required
            label="Combustible"
            value={fuelSelected}
            sx={sxTextFieldDefault}
            onChange={(e) => {
              const value = e.target.value;
              setFuelSelected(value);
              if (setFuel) {
                setFuel(value.toLowerCase());
              }
            }}
            SelectProps={{
              ...selectProps,
              IconComponent: (props) =>
                fuelSelected ? (
                  <Box sx={customIconStyle}>
                    <CheckIcon sx={{ color: 'green', fontSize: 15 }} />
                  </Box>
                ) : (
                  <ArrowDropDownIcon {...props} />
                ),
            }}
          >
            {fuelsNormalized?.map((fuel: any) => (
              <MenuItem key={fuel.id} value={fuel.value}>
                {fuel.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
  required
  label="Precio de venta"
  placeholder="$10.000.000"
  sx={sxTextFieldDefault}
  type="text"
  value={formatPriceDisplay(priceInput)}
  onChange={(e) => {
    const digitsOnly = e.target.value.replace(/\D/g, '');
    setPriceInput(digitsOnly); 
    checkRequiredFields(); 
  }}
  onBlur={() => checkRequiredFields()} 
  InputProps={{
    endAdornment: priceInput ? (
      <Box sx={customIconStyle}>
        <CheckIcon sx={{ color: 'green', fontSize: 15 }} />
      </Box>
    ) : null
  }}
/>
        </div>
      </div>
      <p style={{marginBottom: '50px',fontSize: '16px'}}> Adjunta fotos del vehículo desde diferentes ángulos para que puedan verse los detalles de cada versión.</p>

      <div className={styles.uploadersGrid}>
      
        <div className={styles.uploaderItem}>
          <h3>Foto de atrás *</h3>
          <CustomFileUploader
            values={imagesVideos?.filter(img => img.index === 0) || []}
            onChange={(files: ImageFile[]) => onChangeFileUploader(files, 0)}
            onDeleteItem={handleDeleteImage}
            className={styles.fileUploader}
            placeholderImage={uploaderImages.back}
            loading={
              imagesVideos?.some(img => img.index === 0 && img.upload === "loading")
            }
            deleting={fetchingDeleteImage === "loading"}
            
          />
        </div>
        <Tooltip
          title={!canUploadRequiredImage(1) ? "Por favor, espera a que se complete la carga de la imagen anterior." : ""}
          disableHoverListener={canUploadRequiredImage(1)}
          arrow
        >
          <div className={styles.uploaderItem}>
            <h3>Foto lateral izquierdo *</h3>
            <CustomFileUploader
              values={(isEditing ? imagesVideos : uploadedImagesMeta)?.filter((img: ImageFile) => img.index === 1) || []}
              onChange={(files: ImageFile[]) => onChangeFileUploader(files, 1)}
              onDeleteItem={handleDeleteImage}
              className={styles.fileUploader}
              placeholderImage={uploaderImages.leftSide}
              loading={
                (isEditing ? imagesVideos : uploadedImagesMeta)?.some((img: ImageFile) => img.index === 1 && img.upload === "loading")
              }
              disabled={!canUploadRequiredImage(1)}
              deleting={fetchingDeleteImage === "loading"}
              
            />
          </div>
        </Tooltip>
        <Tooltip
          title={!canUploadRequiredImage(2) ? "Por favor, espera a que se complete la carga de la imagen anterior." : ""}
          disableHoverListener={canUploadRequiredImage(2)}
          arrow
        >
          <div className={styles.uploaderItem}>
            <h3>Foto lateral derecho *</h3>
            <CustomFileUploader
              values={(isEditing ? imagesVideos : uploadedImagesMeta)?.filter((img: ImageFile) => img.index === 2) || []}
              onChange={(files: ImageFile[]) => onChangeFileUploader(files, 2)}
              onDeleteItem={handleDeleteImage}
              className={styles.fileUploader}
              placeholderImage={uploaderImages.rightSide}
              loading={
                (isEditing ? imagesVideos : uploadedImagesMeta)?.some((img: ImageFile) => img.index === 2 && img.upload === "loading")
              }
              disabled={!canUploadRequiredImage(2)}
              deleting={fetchingDeleteImage === "loading"}
              
            />
          </div>
        </Tooltip>
        <Tooltip
          title={!canUploadRequiredImage(3) ? "Por favor, espera a que se complete la carga de la imagen anterior." : ""}
          disableHoverListener={canUploadRequiredImage(3)}
          arrow
        >
          <div className={styles.uploaderItem}>
            <h3>Foto del interior *</h3>
            <CustomFileUploader
              values={(isEditing ? imagesVideos : uploadedImagesMeta)?.filter((img: ImageFile) => img.index === 3) || []}
              onChange={(files: ImageFile[]) => onChangeFileUploader(files, 3)}
              onDeleteItem={handleDeleteImage}
              className={styles.fileUploader}
              placeholderImage={uploaderImages.interior}
              loading={
                (isEditing ? imagesVideos : uploadedImagesMeta)?.some((img: ImageFile) => img.index === 3 && img.upload === "loading")
              }
              disabled={!canUploadRequiredImage(3)}
              deleting={fetchingDeleteImage === "loading"}
              
            />
          </div>
        </Tooltip>


        <Tooltip
          title="Debes subir al menos las 4 fotos principales para poder agregar adicionales"
          disableHoverListener={realImageIds.length >= 4}
          arrow
        >
          <div className={styles.uploaderItem}>
            <h3  >Foto adicional</h3>
            <CustomFileUploader
              values={(isEditing ? imagesVideos : uploadedImagesMeta)?.filter(img => img.index === 4) || []}
              onChange={(files: ImageFile[]) => onChangeFileUploader(files, 4)}
              onDeleteItem={handleDeleteImage}
              className={styles.fileUploader}
              placeholderImage={uploaderImages.additional}
              multiple={true}
              disabled={shouldDisableAdditionalUploader(4)} 
              loading={
                uploadedImagesMeta?.some(img => img.index === 4 && img.upload === "loading")
              }
              deleting={fetchingDeleteImage === "loading"}
           
            />
          </div>
        </Tooltip>
        {additionalUploaders.map((index) => (
          <div key={index} className={styles.uploaderItem}>
            <h3>Foto adicional</h3>
            <CustomFileUploader
              values={(isEditing ? imagesVideos : uploadedImagesMeta)?.filter(img => img.index === (5 + index)) || []}
              onChange={(files: ImageFile[]) => onChangeFileUploader(files, 5 + index)}
              onDeleteItem={handleDeleteImage}
              className={styles.fileUploader}
              placeholderImage={uploaderImages.additional}
              disabled={shouldDisableAdditionalUploader(5 + index)} 
              loading={
                uploadedImagesMeta?.some(img => img.index === (5+ index) && img.upload === "loading")
              }

              deleting={fetchingDeleteImage === "loading"}
              
            />
          </div>
        ))}

        
      </div>

      
      <div className={styles.featuresSection}>
                    <FeaturesList
                        getAdditionalCharacters={getAdditionalCharacters}
                        additionalCharacters={additionalCharacters}
                        selectedFeatures={selectedAdditionalCharacters}
                        setAdditionalCharacters={setAdditionalCharacters}
                        setSelectedAdditionalCharacters={setSelectedAdditionalCharacters}
                    />
                </div>

      <div className={styles.addMoreSection}>

                
                <div className={styles.buttonContainer || styles.continueButtonContainer}>
                <Button
                  onPress={handleContinue}
                  title={
                    isEditing
                      ? "Actualizar versión"
                      : "Guardar versión"
                  }
                  primary
                  disabled={disabledButton}
                  className={styles.submitButton}
                />
                </div>
   
      </div>
    </div>
  );
};

export default StepPictures;